import { call, put, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import {
    uploadProfilePhotoSuccess,
    uploadProfilePhotoFailure,
} from '../../actions/authActions/uploadProfilePhotoActions';

function* uploadProfilePhoto({ payload, callback }) {
    try {
        const formData = new FormData();
        formData.append('file', payload.file);

        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.uploadProfilePhoto,
            payload: formData,
            isAuth: true,
            ContentType: 'multipart/form-data',
        });
        yield put(
            uploadProfilePhotoSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message,
            })
        );
        if (callback && response?.data?.status === 200) {
            callback(response.data.response, response?.data?.status);
        } else if (callback) {
            callback(response.data.message, response?.data?.status);
        }
    } catch (error) {
        console.log('UPLOAD_PROFILE_PHOTO_FAILURE:', error?.response?.data);
        yield put(
            uploadProfilePhotoFailure({
                status: error?.response?.data?.status,
                response: {},
                message: error?.response?.data?.message,
            })
        );
    }
}

function* uploadProfilePhotoSaga() {
    yield takeLatest(actionTypes.UPLOAD_PROFILE_PHOTO_REQUEST, uploadProfilePhoto);
}

export default uploadProfilePhotoSaga;
